import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '中国石化万科内购会';
const baseUrl = '20220511IPM';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'list',
      name: `${baseUrl}-list`,
      component: () => import('./pages/List.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detailone',
      name: `${baseUrl}-detailone`,
      component: () => import('./pages/DetailOne.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detailtwo',
      name: `${baseUrl}-detailtwo`,
      component: () => import('./pages/DetailTwo.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detailthree',
      name: `${baseUrl}-detailthree`,
      component: () => import('./pages/DetailThree.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detailfour',
      name: `${baseUrl}-detailfour`,
      component: () => import('./pages/DetailFour.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'save',
      name: `${baseUrl}-save`,
      component: () => import('./pages/Save.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
